module.exports = __webpack_public_path__ + "assets/img/组 6@2x.dfbfd928.png";